var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefereeTravelplannerFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Travel Planner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.6459 26.0543C29.2292 24.9752 29.6667 23.7418 29.6667 22.3543C29.6667 18.5002 26.7501 15.4168 23.1042 15.4168C19.4584 15.4168 16.5417 18.5002 16.5417 22.3543C16.5417 26.2085 19.4584 29.2918 23.1042 29.2918C24.4167 29.2918 25.5834 28.8293 26.6042 28.2127L31.2709 33.146L33.3126 30.9877L28.6459 26.0543ZM23.1042 26.2085C21.0626 26.2085 19.4584 24.5127 19.4584 22.3543C19.4584 20.196 21.0626 18.5002 23.1042 18.5002C25.1459 18.5002 26.7501 20.196 26.7501 22.3543C26.7501 24.5127 25.1459 26.2085 23.1042 26.2085ZM18.0001 30.8335V33.9168C9.95008 33.9168 3.41675 27.0102 3.41675 18.5002C3.41675 9.99016 9.95008 3.0835 18.0001 3.0835C25.0584 3.0835 30.9355 8.38683 32.2917 15.4168H29.273C28.8182 13.5542 27.9575 11.83 26.7598 10.3818C25.562 8.93358 24.0605 7.80164 22.3751 7.07641V7.7085C22.3751 9.40433 21.0626 10.7918 19.4584 10.7918H16.5417V13.8752C16.5417 14.7231 15.8855 15.4168 15.0834 15.4168H12.1667V18.5002H15.0834V23.1252H13.6251L6.63966 15.7406C6.45008 16.6347 6.33341 17.5443 6.33341 18.5002C6.33341 25.2989 11.5688 30.8335 18.0001 30.8335Z",
    fill: "#00954A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefereeTravelplannerFilled);
export default __webpack_public_path__ + "static/media/referee_travelplanner_filled.35b21b86b31d122259d8ce99364f0eef.svg";
export { ForwardRef as ReactComponent };